import { Outlet } from 'react-router-dom';
import '../assets/styles/Layout.css';

/**
 * Châssis des pages ouvertes par le client depuis le lien reçu par email
 * (signature d'un devis, signature d'un contrat).
 *
 * Volontairement dépouillé : ni barre latérale, ni barre du haut, ni bloc
 * compte. Ces pages étaient rendues dans le Layout interne, si bien que le
 * client voyait la navigation de l'outil de gestion et l'adresse du compte
 * BO&CO. On réutilise `app-content` pour garder les mêmes marges et le même
 * comportement de défilement que le reste de l'application.
 */
function LayoutPublic() {
  return (
    <div className="app-layout app-layout-public">
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}

export default LayoutPublic;
